import '../assets/style/global.css';

const SearchContainer = ({
  placeholder,
  onChangeText,
}: {
  placeholder: string;
  onChangeText: (text: string) => void;
}) => {
  return (
    <div className="search-container">
      <div className="search-box">
        <i
          className="pi pi-search search-icon"
        />
        <input
          className="srch-search-input"
          type="text"
          placeholder={placeholder}
          onChange={e => onChangeText(e.target.value)}
        />
      </div>
    </div>
  );
};

export default SearchContainer;
